import { Expose } from "../serialization/class-transformer/decorators";

export class EnumDataItem {
    
    @Expose()
    enumValue: number;
    
    @Expose()
    enumDisplayName: string;
}